// TODO: использовать везде нативный fetch напрямую
import 'whatwg-fetch';
import camelCase from 'lodash/camelCase';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON(response) {
  if (response.ok) {
    return response.text()
      .then(text => (text ? JSON.parse(text) : {}));
  }

  return response.json()
    .then((err) => {
      if (err.errors) {
        throw mapErrors(Array.isArray(err.errors) ? err.errors : [err.errors]);
      } else {
        throw new Error(response.statusText);
      }
    });
}

function mapErrors(errors) {
  return errors.reduce((obj, error, index) => {
    const errorObject = { ...obj };

    if (error.source && error.source.pointer) {
      const attribute = camelCase(error.source.pointer.split('/').pop());
      errorObject[attribute] = error.detail;
    } else {
      errorObject[index] = error.detail;
    }

    return errorObject;
  }, {});
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 500 && response.status !== 401) {
    return response;
  }

  throw new Error(`Ошибка ${response.status}: ${response.statusText}`);
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => ({ data }))
    .catch((e) => {
      const err = e instanceof Error
        ? [e.message === 'Failed to fetch' ? 'Сетевая ошибка. Попробуйте ещё раз' : e.message]
        : e;
      return { err };
    });
}
